import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Adjunta las cookies en cada peticion.
 *
 * En este perfil no es un detalle: la sesion viaja en cookies `HttpOnly` que la
 * aplicacion no puede leer ni escribir. Sin `withCredentials` el navegador NO
 * las manda y todas las llamadas responden 401, sin ningun indicio de por que.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    withCredentials: true,
  });
  return next(clonedRequest);
};
